/** Тексты пространства «api». Ключи именуются по смыслу, а не по месту. */
export const api = {
  /* ── Расшифровки перечислений ───────────────────────────────────────── */

  role: {
    player: 'Игрок',
    form_moderator: 'Модератор анкет',
    quest_master: 'Квест-мастер',
    superadmin: 'Суперадмин',
  },

  /* В единственном: это слово про одного. Группы называет `registry.tab`. */
  characterKind: {
    personnel: 'Сотрудник',
    resident: 'Житель',
    professor: 'Преподаватель',
  },

  dorm: {
    o1: 'О-1',
    o2: 'О-2',
    o3: 'О-3',
  },

  studyClass: {
    e1: 'E-1',
    e2: 'E-2',
    d1: 'D-1',
    d2: 'D-2',
    c: 'C',
    b: 'B',
    a: 'A',
  },

  moderationTarget: {
    form: 'Анкета',
    item: 'Предмет',
    pet: 'Питомец',
    ability: 'Способность',
  },

  reviewStatus: {
    draft: 'Черновик',
    pending: 'На проверке',
    approved: 'Принята',
    rejected: 'Отклонена',
  },

  abilityOrigin: {
    form: 'Из анкеты',
    granted: 'Выдана в игре',
  },

  abilityKind: {
    ability: 'Способность',
    debuff: 'Дебаф',
  },

  /* ── Подписи полей анкеты ───────────────────────────────────────────── */

  formField: {
    nameRu: 'ФИО на русском',
    nameEn: 'ФИО на английском',
    nicknames: 'Прозвища и сокращения',
    gender: 'Пол',
    age: 'Возраст',
    familyText: 'Семья и родственники на территории Королевства',
    race: 'Раса',
    appearanceText: 'Внешность',
    appearanceImageId: 'Изображение внешности',
    personalityText: 'Характер, ценности и моральные отклонения',
    biographyText: 'Биографический очерк',
    abilities: 'Особые способности',
    molesCount: 'Количество родинок на теле',
  },

  /* ── Свои тексты ошибок ─────────────────────────────────────────────── */

  /**
   * Запасные формулировки клиента: их показывают, когда сервер не назвал
   * причину сам. Английский текст сервера сюда не уезжает — его показывают
   * как есть.
   */
  error: {
    unauthorized: 'Сессия закончилась. Откройте приложение заново.',
    forbidden: 'Не хватает прав на это действие.',
    notFound: 'Не нашли то, что вы открыли.',
    conflict: 'Данные успели измениться. Обновите страницу.',
    tooLarge: 'Файл слишком большой.',
    tooManyRequests: 'Слишком много запросов подряд. Подождите минуту.',
    server: 'Сервер не ответил как надо. Попробуйте позже.',
    request: 'Запрос не прошёл.',
    network: 'Сеть не отвечает. Проверьте соединение и попробуйте снова.',
    unknown: 'Что-то пошло не так.',
  },
} as const;
